/**
 * StaffGeschaeft — IT-SCE Intern: "Geschäft"-Sektion (Sidebar-Link existierte
 * bereits, zeigte bisher ins Leere — Layout.tsx `/staff/invoices`).
 *
 * TQ #9695 (Staff-Migration Teil B, Bundle #9523). Buendelt 3 migrierte
 * Seiten (Rechnungen, Subscriptions, Subscription-Plans) unter EINER Route
 * via Tabs, weil die Sidebar nur einen einzigen "Geschäft"-Link hat (kein
 * Sub-Menu) — Routing-Entscheidung dieses Sub-Tasks.
 */

import { useState } from 'react'
import StaffInvoices from './StaffInvoices'
import StaffSubscriptions from './StaffSubscriptions'
import StaffSubscriptionPlans from './StaffSubscriptionPlans'

type Tab = 'invoices' | 'subscriptions' | 'plans'

const TABS: { key: Tab; label: string; icon: string }[] = [
  { key: 'invoices', label: 'Rechnungen', icon: '📑' },
  { key: 'subscriptions', label: 'Subscriptions', icon: '🔁' },
  { key: 'plans', label: 'Subscription-Plans', icon: '💳' },
]

export default function StaffGeschaeft() {
  const [tab, setTab] = useState<Tab>('invoices')

  return (
    <div>
      <div
        role="tablist"
        aria-label="Geschäft"
        style={{
          display: 'flex', gap: 4, padding: '0 1.5rem', marginTop: '1.5rem',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        {TABS.map((t) => (
          <button
            key={t.key}
            role="tab"
            aria-selected={tab === t.key}
            onClick={() => setTab(t.key)}
            style={{
              padding: '0.75rem 1rem',
              border: 'none',
              borderBottom: tab === t.key ? '2px solid #2563eb' : '2px solid transparent',
              background: 'transparent',
              color: tab === t.key ? '#2563eb' : '#374151',
              fontWeight: tab === t.key ? 600 : 500,
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {tab === 'invoices' && <StaffInvoices />}
      {tab === 'subscriptions' && <StaffSubscriptions />}
      {tab === 'plans' && <StaffSubscriptionPlans />}
    </div>
  )
}
